import permissions, { RESOURCE_ACTIVO_FIJO_PG } from '@/auth/permissions/modules/activoFijoPg'
import {
    ROUTE_INFORME_ACTIVO_FIJO_CON_ALTA_CONTABLE,
    ROUTE_INFORME_ACTIVO_FIJO_SIN_ALTA_CONTABLE,
    ROUTE_INFORME_ACTIVO_FIJO_X_TIPO,
    ROUTE_INFORME_AVALUOS,
    ROUTE_INFORME_DEPRECIACION_ACTIVOS_FIJOS,
} from '@/router/routes/activo-fijo-pg/names'
import { defineMenu } from '@/utils/menu'

const { informes } = permissions

export default defineMenu([
    {
        title: 'activo_fijo_pg.subopciones.activo_fijo_x_tipo',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: informes.activoFijoXTipo,
        route: ROUTE_INFORME_ACTIVO_FIJO_X_TIPO,
    },
    {
        title: 'activo_fijo_pg.subopciones.activo_fijo_sin_alta_contable',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: informes.activoFijoSinAltaContable,
        route: ROUTE_INFORME_ACTIVO_FIJO_SIN_ALTA_CONTABLE,
    },
    {
        title: 'activo_fijo_pg.subopciones.activo_fijo_con_alta_contable',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: informes.activoFijoConAltaContable,
        route: ROUTE_INFORME_ACTIVO_FIJO_CON_ALTA_CONTABLE,
    },
    {
        title: 'activo_fijo_pg.subopciones.depreciacion_activos_fijos',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: informes.depreciacionActivosFijos,
        route: ROUTE_INFORME_DEPRECIACION_ACTIVOS_FIJOS,
    },
    {
        title: 'activo_fijo_pg.subopciones.avaluos',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: informes.avaluosActivoFijo,
        route: ROUTE_INFORME_AVALUOS,
    },
])
